<template>
	<div>
		<div class="title-container">
			<div class="title">
				<span class="fa fa-globe"></span>{{ account.name }}
				<div class="subtitle">Respond To Account Invitation</div>
			</div>
		</div>
		<div v-if="submittedResponse && !responseForm.accept" class="input-container">
			<div class="input-static-text">Your invitation to manage the <b>{{ account.name }}</b> account has been declined. No further action is required.</div>
		</div>
		<div v-if="submittedResponse && responseForm.accept" class="input-container">
			<div class="input-static-text">To complete your acceptance of the invitation, please {{ responseForm.hasAccount ? 'login' : 'sign up' }} below.</div>
		</div>
		<div v-if="!submittedResponse" class="input-container">
			<div class="input-static-text">Please respond to your invitation to manage the <b>{{ account.name }}</b> account below!</div>
		</div>

		<form v-if="!submittedResponse" action="/" @submit.prevent="onResponseFormSubmit">
			<div class="input-container">
				<label class="input-radio">
					<input type="radio" name="radio" v-model="responseForm.accept" :value="1">
					<span class="radio-checkmark"></span>
					<div class="radio-text">Accept Invitation</div>
				</label>
				<label class="input-radio">
					<input type="radio" name="radio" v-model="responseForm.accept" :value="0">
					<span class="radio-checkmark"></span>
					<div class="radio-text">Decline Invitation</div>
				</label>
			</div>
			<div v-if="responseForm.accept" class="input-container">
				<div class="input-checkbox">
					<span class="checkmark-container">
						<label class="checkbox">
							<input type="checkbox" id="has_account" name="has_account" v-model="responseForm.hasAccount" :value="1">
							<span class="checkmark"></span>
						</label>
					</span>
					<label for="has_account" class="input-checkbox-text">I already have a Gravity Fox account</label>
				</div>
			</div>
			<button v-if="responseForm.accept" type="submit" class="submit-standard good-bg">Accept<span class="fa fa-thumbs-up"></span></button>
			<button v-if="responseForm.accept === 0" type="submit" class="submit-standard bad-bg">Decline<span class="fa fa-thumbs-down"></span></button>
		</form>

		<login-form v-show="submittedResponse && responseForm.hasAccount" v-model="authForm" :action="onAuthFormSubmit"></login-form>
		<sign-up-form v-show="submittedResponse && !responseForm.hasAccount" v-model="authForm" :action="onAuthFormSubmit"></sign-up-form>
	</div>
</template>

<script>

import { mapGetters } from 'vuex';
import { AuthMixin, FormMixin } from '@/mixins';
import LoginForm from '../auth/forms/LoginForm';
import SignUpForm from '../auth/forms/SignUpForm';

export default {

	mixins: [ AuthMixin, FormMixin ],

	props: [ 'account', 'invitation', 'accept' ],

	data() {
		return {
			loading: true,
			submittedResponse: null,
			responseForm: {
				accept: 1,
			},
			authForm: {},
			error: null,
		};
	},

	computed: {

		...mapGetters([ 'isLoggedIn', 'currentUser' ]),

	},

	methods: {

		onResponseFormSubmit() {
			this.submittedResponse = true;

			if (this.responseForm.accept === 0) {
				// Decline Invite
				this.$emit('reject');
			} else {
				this.$set(this.authForm, 'email', this.invitation.user.email);
			}
		},

		onAuthFormSubmit() {
			return new Promise((resolve, reject) => {
				this.submit(async () => {
					await (this.responseForm.hasAccount ? this.onSubmitLogin(this.authForm) : this.onSubmitSignup(this.authForm));
					await this.accept();

					resolve();
				}, (e) => {
					this.$store.dispatch('errorToast', 'There was a problem accepting this invitation. Please try again later.');

					if (this.responseForm.hasAccount) {
						this.$store.dispatch('logout');
					}

					reject(e);

				});
			});
		},

	},

	components: {
		LoginForm,
		SignUpForm,
	}

};

</script>
